<template>
    <div>
        <!-- 月報 v.0.0
            2019.07 的版本，只畫出基本 RowData 圖表
        -->
        <!-- 封面區域 -->
        <ReportCover v-if="report_log_time && RData_cropperiod"
                    :report_type="'monthly'"
                    :cropperiod_data="RData_cropperiod"
                    :log_time="report_log_time"
                    @date-month="date_month = $event"
                    @date-range="date_range = $event"
                    @report-url="report_url = $event"
                    @save-name="report_save_name = $event"
        ></ReportCover>
        
        
        <div class="print-background">

            <!-- 氣象預報 -->
            <div id="weather-data-forecasts" class="print-hide-object">
                <div v-if="report_data && report_data.cwb">
                    <CWBWeatherForecasts :weather_data="report_data.cwb" :default_showCollapse="false"></CWBWeatherForecasts>
                    <hr>
                </div>
            </div>
        
            <div class="report-area">
                <div class="report-area-title-tag" id="page-overview">{{ $t('report.ui.overview') }}</div>
                <div class="report-area-card report-select-area" v-if="RData_cropperiod">
                    <b-row>
                        <b-col md=4>
                            <div v-if="RData_cropperiod.pic"
                                class="cropperiod-img cover-bg"
                                alt="cropperiods photo"
                                :style="$tools.style.imgCover( $config.checkURL('cropperiod', RData_cropperiod.pic) )"
                            ></div>
                            <div v-if="RData_cropperiod.project_logo" class="report-project-logo">
                                <!-- 專案 logo -->
                                <img v-if="RData_cropperiod.project_logo"
                                    class="proj-logo block-sm"
                                    :src="$config.checkURL('pic', RData_cropperiod.project_logo)"
                                    :alt="RData_cropperiod.project_name + ' logo'" >
                            </div>
                        </b-col>
                        <b-col md=8>
                            <!-- <div class="overview-device-title">{{ $t('menu.cropping_season_information') }}</div> -->
                            <div>
                                <!-- 品種 -->
                                <h2 class="card-subtitle mb-3 agri-color-sub">
                                    <i class="fa fa-leaf block-title"></i>
                                    <div class="block-text">
                                        <div class="block-text" v-if="RData_cropperiod.cropinfo.crop_name[ user_language ]">
                                            {{ RData_cropperiod.cropinfo.crop_name[ user_language ] }}
                                        </div>
                                        <div v-else>{{ RData_cropperiod.cropinfo.crop_name.en }}</div>

                                        <div v-if="RData_cropperiod.cropinfo.cultivar_name[ user_language ]" class="block-text">
                                            {{ RData_cropperiod.cropinfo.cultivar_name[ user_language ] }}
                                        </div>
                                        <div v-else>{{ RData_cropperiod.cropinfo.cultivar_name.en }}</div>
                                    </div>

                                    
                                    <!-- Print & Share Link -->
                                    <div class="block-text print-hide-object">
                                        <!-- <BtnPrint :btn_text="$t('menu.print')" btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false"></BtnPrint> -->
                                        <BtnCopyToClipboard :copy_content="report_url"
                                                            :btn_text="$t('menu.copy_report_link')"
                                                            btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false">
                                        </BtnCopyToClipboard>
                                        <BtnSavePDF v-if="user != undefined && user.id != undefined && getToken != undefined"
                                                    :save_id="'page-top'"
                                                    :save_type="'PDF'"
                                                    :save_filename="report_save_name"
                                                    :save_url="report_url"
                                                    :save_preview="false"
                                                    :log_detail="getLogDetail"
                                                    :copy_content="report_url" :btn_text="$t('menu.download')"
                                                    btn_style="btn-cp" :btn_variant="'outline-warning'" :show_tooltip="false">
                                        </BtnSavePDF>
                                    </div>
                                </h2>

                                <!-- 敘述 -->
                                <div class="card-subtitle mb-2">
                                    <div class="block-text">{{ RData_cropperiod.description }}</div>
                                </div>
                            </div>

                            <b-row>

                                <b-col cols=12 md=6>
                                    <!-- 時區 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="fa fa-clock-o block-text"></i>
                                        <div class="block-text">{{ $t('menu.timezone') }}:</div>
                                        <div class="block-text">{{ RData_cropperiod.project_timezone }}</div>
                                    </div>
                                </b-col>

                                <b-col cols=12 md=6>
                                    <!-- 開始日期 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="fa fa-calendar block-text"></i>
                                        <div class="block-text">{{ $t('menu.planting_day') }}:</div>
                                        <div class="block-text">{{ RData_cropperiod.start_date }}</div>
                                    </div>
                                    <!-- 結束日期 -->
                                    <div class="card-subtitle mb-2" v-if="RData_cropperiod.end_date">
                                        <i class="fa fa-calendar block-text"></i>
                                        <div class="block-text">{{ $t('menu.end_date') }}:</div>
                                        <div class="block-text">{{ RData_cropperiod.end_date }}</div>
                                    </div>
                                </b-col>

                                <b-col cols=12 md=6>
                                    <!-- 面積 -->
                                    <div class="card-subtitle mb-2">
                                        <div class="block-text">
                                            <UnitConvertorArea :area="RData_cropperiod.area" :density="RData_cropperiod.density" defaultUnit="m2" :timezone="RData_cropperiod.project_timezone"
                                                            pageType="cropperiod" selectorType="dropdown"></UnitConvertorArea>
                                        </div>
                                    </div>
                                </b-col>

                                <b-col cols=12 md=6>
                                    <!-- 田區 -->
                                    <div class="card-subtitle mb-2">
                                        <i class="cui-dashboard block-text"></i>
                                        <div class="block-text">{{ $t('n.field') }}:</div>
                                        <div class="block-text">{{ RData_cropperiod.farm_field }}</div>
                                    </div>
                                </b-col>

                            </b-row>
                        </b-col>
                    </b-row>
                </div>
                <div class="report-area-card">

                    <b-row align-v="start">
                        <b-col md="8">
                                <br>
                                <!-- 積溫 Bar -->
                                <DrawCropStage  :data_growth_period="report_data.growth_period"
                                                :show_title="true"
                                                @cgp-data="cgp_data = $event"
                                                @cgp-list="cgp_list = $event"
                                                @cgp-now="cgp_now = $event"
                                ></DrawCropStage>
                        </b-col>
                        <b-col md="4" v-if="cgp_now">
                            
                                <!-- 種植天數 -->
                                <div class="overview-block">
                                    <div class="overview-block-title">{{ $t('menu.days_after_planting') }}</div>
                                    <div class="overview-block-body">{{ cgp_now.count_past }} / {{ cgp_now.count_total }}</div>
                                    <div class="overview-block-unit">{{ $t('u.days') }}</div>
                                </div>

                                <!-- 生長階段 -->
                                <div class="overview-block">
                                    <div class="overview-block-title">{{ $t('menu.current_growth_stage') }}</div>
                                    <div class="overview-block-body">{{ cgp_now.name[ user_language ] }} {{ cgp_now.period[ 0 ] }}</div>
                                    <div class="overview-block-unit">{{ $t('u.days') }}</div>
                                </div>

                                <!-- 下一個生長階段 -->
                                <div class="overview-block" v-if="cgp_now.next">
                                    <div class="overview-block-title">{{ $t('menu.days_to_next_stage') }}</div>
                                    <div class="overview-block-body">{{ cgp_now.next.day_next }}</div>
                                    <div class="overview-block-unit">{{ $t('u.days') }}</div>　=>　
                                    <div class="overview-block-body">{{ cgp_now.next.name[ user_language ] }}</div>
                                </div>
                                
                                <br>
                        </b-col>
                        
                    </b-row>
                    <b-row align-v="start">

                        <b-col md="12" v-if="RData_weatherboxs.length > 0">

                            <div>
                                <div class="overview-device-title">{{ $t('n.weatherbox') }}</div>
                            </div>
                            <b-row>
                                <b-col md=6 v-for="(device, idx_d_overview) in RData_weatherboxs" :key="idx_d_overview">
                                    <div class="overview-device-block">
                                        <div class="device-info">
                                            <div class="device-up-info">{{ device.hashid }}</div>
                                            <div class="device-name">
                                                <i :class="$tools.style.classIcon(device.type, 'block-title')"></i>
                                                <span v-if="device.nickname">{{ device.nickname }}</span>
                                                <span v-else>{{ device.hashid }}</span>
                                            </div>
                                        </div>

                                        <div class="overview-stress" v-for="(alert_info, alert_code, idx_a) in device.alerts" :key="idx_a">
                                            <div type="button"
                                                :class="'btn-stress btn-stress_' + alert_code"
                                                v-html="getStressBtnText(alert_code)">
                                            </div>
                                            <div class="overview-stress-count">{{ alert_info }}</div>
                                        </div>
                                        <div class="device-down-info" v-if="device.meta.description">{{ device.meta.description }}</div>
                                    </div>
                                </b-col>
                            </b-row>

                        </b-col>
                        <b-col md="12" v-if="RData_devices.length > 0">

                            <div>
                                <div class="overview-device-title">{{ $t('n.device') }}</div>
                            </div>
                            <b-row>
                                <b-col md=6 v-for="(device, idx_d_overview) in RData_devices" :key="idx_d_overview">
                                    <div class="overview-device-block">
                                
                                        <div class="device-info">
                                            <div class="device-up-info">{{ device.hashid }}</div>
                                            <div class="device-name">
                                                <i :class="$tools.style.classIcon(device.type, 'block-title')"></i>
                                                <span v-if="device.nickname">{{ device.nickname }}</span>
                                                <span v-else>{{ device.hashid }}</span>
                                            </div>
                                        </div>

                                        <div class="device-info">
                                            <div class="overview-stress" v-for="(alert_info, alert_code, idx_a) in device.alerts" :key="idx_a">
                                                <div type="button"
                                                    :class="'btn-stress btn-stress_' + alert_code"
                                                    v-html="getStressBtnText(alert_code)">
                                                </div>
                                                <div class="overview-stress-count">{{ alert_info }}</div>
                                            </div>
                                        </div>
                                        <div class="device-down-info" v-if="device.meta.description">{{ device.meta.description }}</div>
                                    </div>
                                </b-col>
                            </b-row>

                        </b-col>
                    </b-row>
                </div>
            </div>
            
            <div class="report-area" v-if="RData_weatherboxs.length > 0">
                <div class="report-area-title-tag" id="report-area-air">{{ $t('report.ui.air') }}</div>
                <div class="report-area-card" v-for="(device, idx_d_air) in RData_weatherboxs" :key="idx_d_air">
                    <b-row align-v="center">
                        <b-col class="col-12 col-lg-8">
                            <div class="print-chart-scroll">
                                <div class="print-chart-area">
                                    <MixChartMinMaxParamData v-if="device.log_time" :chartID="'device-chart-' + device.hashid + '-air-' + idx_d_air"
                                                        :info_type="'report'"
                                                        :time="device.log_time"
                                                        :dataList="device.air"
                                                        :dataDisplaySettings="getChartDisplaySetting('air', device)"
                                                        :chartTitle="'Report Air Chart'"
                                                        :showToolbox="true"
                                                        :xAxisName="'date'" :xAxisFormat="'MM/DD'" ></MixChartMinMaxParamData>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="col-12 col-lg-4">
                            <b-alert show variant="success">
                                <h4 class=""><i :class="$tools.style.classIcon(device.type, 'block-title')"></i>{{ device.hashid }} {{ device.nickname }}</h4>
                                <div>
                                    <div class="block-text">{{ $t('sensor.avg_daily_temp') }} ：</div>
                                    {{ device.air.air_temperature_mean_mean }} {{ $t('sensor.u_air_temperature_mean') }}
                                </div>
                                <div>
                                    <div class="block-text">{{ $t('sensor.avg_daily_high_temp') }} ：</div>
                                    {{ device.air.air_temperature_max_mean }} {{ $t('sensor.u_air_temperature_max') }}
                                </div>
                                <div>
                                    <div class="block-text">{{ $t('sensor.avg_daily_low_temp') }} ：</div>
                                    {{ device.air.air_temperature_min_mean }} {{ $t('sensor.u_air_temperature_min') }}
                                </div>
                            </b-alert>
                        </b-col>
                    </b-row>
                </div>
            </div>
            
            <div class="report-area" v-if="RData_weatherboxs.length > 0">
                <div class="report-area-title-tag" id="report-area-sun">{{ $t('report.ui.sun') }}</div>
                <div class="report-area-card" v-for="(device, idx_d_sun) in RData_weatherboxs" :key="idx_d_sun">
                    <b-row align-v="center">
                        <b-col class="col-12 col-lg-8">
                            <div class="print-chart-scroll">
                                <div class="print-chart-area">
                                    <MixChartMultipleParams v-if="device.log_time" :chartID="'device-chart-' + device.hashid + '-sun-' + idx_d_sun"
                                                        :info_type="'report'"
                                                        :time="device.log_time"
                                                        :dataList="device.solar"
                                                        :dataDisplaySettings="getChartDisplaySetting('sun', device)"
                                                        :chartTitle="'Report Sun Chart'"
                                                        :showToolbox="true"
                                                        :xAxisName="'date'" :xAxisFormat="'MM/DD'" ></MixChartMultipleParams>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="col-12 col-lg-4">
                            <b-alert show variant="warning">
                                <h4 class=""><i :class="$tools.style.classIcon(device.type, 'block-title')"></i>{{ device.hashid }} {{ device.nickname }}</h4>
                                <div>
                                    <div class="block-text">{{ $t('sensor.acc_solar_radiation') }} ：</div>
                                    {{ device.solar.solar_mj_mean }} {{ $t('sensor.u_solar_mj') }}
                                </div>
                                <div>
                                    <div class="block-text">{{ $t('sensor.acc_sun_hours') }} ：</div>
                                    {{ device.solar.solar_hour_mean }} {{ $t('sensor.u_solar_hour') }}
                                </div>
                            </b-alert>
                        </b-col>
                    </b-row>
                </div>
            </div>
            
            <div class="report-area" v-if="RData_weatherboxs.length > 0">
                <div class="report-area-title-tag" id="report-area-water">{{ $t('report.ui.water') }}</div>
                <div class="report-area-card" v-for="(device, idx_d_water) in RData_weatherboxs" :key="idx_d_water">
                    <b-row align-v="center">
                        <b-col class="col-12 col-lg-8">
                            <div class="print-chart-scroll">
                                <div class="print-chart-area">
                                    <MixChartMultipleParams v-if="device.log_time" :chartID="'device-chart-' + device.hashid + '-water-' + idx_d_water"
                                                        :info_type="'report'"
                                                        :time="device.log_time"
                                                        :dataList="device.water"
                                                        :dataDisplaySettings="getChartDisplaySetting('water', device)"
                                                        :chartTitle="'Report Water Chart'"
                                                        :showToolbox="true"
                                                        :xAxisName="'date'" :xAxisFormat="'MM/DD'" ></MixChartMultipleParams>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="col-12 col-lg-4">
                            <b-alert show variant="info">
                                <h4 class=""><i :class="$tools.style.classIcon(device.type, 'block-title')"></i>{{ device.hashid }} {{ device.nickname }}</h4>
                                <div>
                                    <div class="block-text">{{ $t('sensor.acc_rainfall') }} ：</div>
                                    {{ device.water.rainfalls_sum }} {{ $t('sensor.u_rainfalls') }}
                                </div>
                            </b-alert>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <div class="report-area" v-if="RData_devices.length > 0">
                <div class="report-area-title-tag" id="report-area-devices">{{ $t('n.device') }} {{ $t('menu.sensor_parameter') }}</div>
                <div class="report-area-card report-select-area">
                    <div class="area-overflow-x grab-bing scroll-style block-area" v-dragscroll>
                        <b-form-group>
                            <b-form-radio-group v-model="selected_sensorParams" buttons>
                                <b-form-radio v-for="(datalist, key, idx_dsps) in RData_sensorParams" :key="idx_dsps"
                                                :value="key" button-variant="outline-success"
                                >{{ $t('sensor.' + key) }} ({{ datalist.length }})
                                </b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                </div>
                <div class="report-area-card" v-if="chartDisplaySetting_Devices">
                    <b-row align-v="center">
                        <b-col class="col-12 col-lg-8">
                            <div class="print-chart-scroll">
                                <div class="print-chart-area">
                                    <MixChartMultipleParams v-if="RData_device_log_time && chartDisplaySetting_Devices.deviceSettings"
                                                        :chartID="'devices-chart-sensor-params-' + selected_sensorParams"
                                                        :info_type="'report'"
                                                        :time="RData_device_log_time"
                                                        :dataList="chartDisplaySetting_Devices.deviceData"
                                                        :dataDisplaySettings="chartDisplaySetting_Devices.deviceSettings"
                                                        :chartTitle="$t('sensor.' + selected_sensorParams)"
                                                        :showToolbox="true"
                                                        :xAxisName="'date'" :xAxisFormat="'MM/DD HH:mm'" ></MixChartMultipleParams>
                                </div>
                            </div>
                        </b-col>
                        <b-col class="col-12 col-lg-4">
                            <b-alert show variant="info">
                                <h4 class="">{{ $t('sensor.' + selected_sensorParams) }}</h4>
                                <div v-for="(device, idx_d) in chartDisplaySetting_Devices.device" :key="idx_d">
                                    <i :class="$tools.style.classIcon(device.type, 'block-title')"></i>
                                    {{ device.hashid }} {{ device.nickname }}
                                    ( {{ device.hour_count_all }} )
                                    <!-- ( {{ $t('menu.data_count') }}： {{ device.hour_count_all }} ) -->
                                </div>
                            </b-alert>
                        </b-col>
                    </b-row>
                </div>
            </div>

            <div class="report-area print-hide-object">
                <div class="report-area-title-tag" id="report-area-comment">{{ $t('report.ui.comment') }}</div>
                <div class="report-area-card">
                    <ReportComment :page_type="'report'" :page_id="getReportID" :user="user" :timezone="timezone"></ReportComment>
                </div>
            </div>
            
            <!-- 放在最下方 -->
            <ButtonTopRight :dropdown="dropdownList"></ButtonTopRight>

        </div>

    </div>
</template>


<script>
import { mapState } from 'vuex'
import { dragscroll } from 'vue-dragscroll'  // 滑鼠可拖拉 scroll 區域
import DrawCropStage from '@/views/components/Draw_CropStage'
import ButtonTopRight from '@/views/components/Button_TopRight'
import BtnCopyToClipboard from '@/views/components/Button_CopyToClipboard'
import BtnSavePDF from '@/views/components/Button_SavePDF'
import BtnPrint from '@/views/components/Button_Print'
import UnitConvertorArea from '@/views/components/UnitConvertor_Area'
import ecTools from '@/echarts/echarts-tools'
import MixChartMultipleParams from '@/views/echarts/MixChart_MultipleParams'
import MixChartMinMaxParamData from '@/views/echarts/MixChart_MinMaxParamData'
import CWBWeatherForecasts from '@/views/project/report/components/CWB_WeatherForecasts'
import ReportCover from '@/views/project/report/components/ReportCover'
import ReportComment from '@/views/project/report/components/ReportComment'

export default {
    props: {
        report_data: {
            type: Object,
            require: true,
        },
        user: {
            type: Object,
            default: undefined,
        },
        timezone: {
            type: String,
            default: undefined,
        },
    },
    directives: {
        'dragscroll': dragscroll,
    },
    components: {
        ReportCover,
        CWBWeatherForecasts,
        DrawCropStage,
        ButtonTopRight,
        BtnCopyToClipboard,
        BtnSavePDF,
        BtnPrint,
        ReportComment,
        UnitConvertorArea,
        MixChartMultipleParams,
        MixChartMinMaxParamData,
    },
    data () {
        return {
            loading: false,
            project_name: undefined,
            cropperiod_name: undefined,

            date_month: '',
            date_range: '',
            report_url: '',
            report_save_name: '',
            report_log_time: [],
            cgp_data: undefined,
            cgp_list: undefined,
            cgp_now: undefined,

            RData_cropperiod: undefined,
            RData_weatherboxs: [],
            RData_devices: [],
            RData_device_log_time: [],
            RData_sensorParams: {},
            selected_sensorParams: undefined,
            chartDisplaySetting_Devices: undefined,
            
        }
    },
    mounted ()
    {
        if (this.timezone == undefined) this.timezone = this.$tools.date.getTimezoneNow();
        if (this.report_data != undefined)
        {
            this.getReport()
        }
    },
    computed: {
        ...mapState({
            'user_language': state => state.user.language,
        }),

        getToken ()
        {
            return localStorage.token
        },
        getReportID ()
        {
            if ( this.$route.query && this.$route.query.id )
                return this.$route.query.id
            else undefined
        },

        dropdownList ()
        {
            let _list = [
                { icon: 'fa fa-paw', name_code: 'go_top', name: 'Top', href: '#page-top', },
                { icon: 'fa fa-paw', name: 'Overview', href: '#page-overview', },
                // { icon: 'wi wi-raindrop', name_code: 'weather_forecast', name: 'Forecast', href: '#yahoo-weather', },
            ]
            if (this.report_data)
            {
                if (this.report_data.cwb)
                {
                    _list.push( { icon: 'wi wi-raindrop', name_code: 'weather_forecast', name: 'Forecast', href: '#weather-data-forecasts' } )
                }
                if (this.RData_weatherboxs.length > 0)
                {
                    _list.push( { icon: this.$tools.style.classIcon('weatherbox'), name: 'Air', href: '#report-area-air', }, )
                    _list.push( { icon: this.$tools.style.classIcon('weatherbox'), name: 'Sun', href: '#report-area-sun', }, )
                    _list.push( { icon: this.$tools.style.classIcon('weatherbox'), name: 'Water', href: '#report-area-water', }, )
                }
                if (this.RData_devices.length > 0)
                {
                    _list.push( { icon: this.$tools.style.classIcon('wand'), name: this.$t('n.device'), href: '#report-area-devices' }, )
                }

                _list.push( { icon: 'fa fa-pencil', name_code: 'comment', name: 'Comment', href: '#report-area-comment' } )
            }
            // console.log( _list )

            return _list
        },

        getLogDetail ()
        {
            return {
                page: 'report monthly',
                action: 'download pdf',
                querySettings: {
                    'project ID':       this.report_data.cropperiod_meta.project_id,
                    'cropperiod ID':    this.report_data.cropperiod_meta.id,
                    'cropperiod name':  this.report_data.cropperiod_meta.name,
                    'report name':      this.date_month + ' ' + this.$t('menu.analysis_report'),
                    'report type':      'monthly',
                    'report range':     this.date_range,
                    'report ID':        this.$route.query.id,
                    'report url':       this.report_url,
                },
                pageInfo: {
                    'project timezone':     this.report_data.cropperiod_meta.project_timezone,
                    'project status':       this.report_data.cropperiod_meta.project_status,
                },
            }
        },

    },
    watch: {

        report_data (val, oldVal)
        {
            if (val)
            {
                this.getReport()
            }
        },

        selected_sensorParams (val, oldVal)
        {
            if (val)
            {
                this.getChartDisplaySetting_Devices(val)
            }
        },
    },
    methods: {

        getStressBtnText (alert_code)
        {
            return `<i class="${ this.$tools.style.classStressIcon( alert_code, 'block-text' ) }"></i>${ this.$t('stress.' + alert_code) }`;
        },

        addGeneralStandards (_refreshRules)
        {
            _refreshRules['rain_rate'] = ecTools.getGeneralStandard('rainfalls', this.$t('chart'));
            _refreshRules['rainfalls'] = ecTools.getGeneralStandard('rainfalls', this.$t('chart'));

            _refreshRules['rainfalls_1h'] = ecTools.getGeneralStandard('rainfalls_1h', this.$t('chart'));
            _refreshRules['rainfalls_3h'] = ecTools.getGeneralStandard('rainfalls_3h', this.$t('chart'));
        },

        // 取得多參數圖表要用的資料設定
        getChartDisplaySetting (chartCategory, device)
        {
            let _settings = []
            let _standard = {}
            this.addGeneralStandards( _standard )

            switch (chartCategory)
            {
                case 'air':
                    _settings = [
                        ecTools.sensorMapping( 'air_temperature_mean', device ),
                        ecTools.sensorMapping( 'air_temperature_min', device ),
                        ecTools.sensorMapping( 'air_temperature_max', device ),
                    ];
                    _settings[1].chart_type = 'line_area_min'
                    _settings[2].chart_type = 'line_area_max'
                    break;

                case 'sun':
                    _settings = [
                        ecTools.sensorMapping( 'solar_hour', device ),
                        ecTools.sensorMapping( 'solar_mj', device ),
                    ];
                    break;
                case 'water':
                    _settings = [
                        ecTools.sensorMapping( 'rainfalls', device, 'rainfalls', false, _standard ),
                    ];
                    break;
                default: _settings = []; break;
            }

            return _settings;
        },


        getChartDisplaySetting_Devices (paramKey)
        {
            this.chartDisplaySetting_Devices = undefined;

            let _settings = {
                deviceData: {},
                deviceSettings: [],
                device: [],
            }

            this.RData_sensorParams[ paramKey ].forEach( _included_device => {

                _settings.deviceData[ _included_device.compare_key ] = _included_device.data
                _settings.device.push( _included_device.device )
                _settings.deviceSettings.push( ecTools.sensorMapping( _included_device.compare_key, _included_device.device, paramKey, false ) )
            })
            
            if ( _settings.deviceSettings.length > 0 )
            this.chartDisplaySetting_Devices = _settings;
            
        },
        // 取得裝置所有感測項目的列表
        getSensorParams ()
        {
            let _sensorParams = {}
            if ( this.RData_devices.length > 0 )
            {
                this.RData_device_log_time = this.RData_devices[0].log_time;

                this.RData_devices.forEach( _device => {
                    
                    for (let _paramKey in _device.all_data)
                    {
                        switch ( _paramKey )
                        {
                            case 'voltage': break; // 不顯示的就直接 break 跳出
                            case 'rssi':    break;
                            case 'snr':     break;
                            default:
                                if ( _sensorParams[ _paramKey ] == undefined ) _sensorParams[ _paramKey ] = []
                                _sensorParams[ _paramKey ].push({
                                    compare_key: _device.hashid + '_' + _paramKey,
                                    device: {
                                        type: _device.type,
                                        hashid:   _device.hashid,
                                        nickname: _device.nickname,
                                        hour_count_all: _device.hour_count_all,
                                    },
                                    data: _device.all_data[ _paramKey ],
                                })
                        }
                    }


                })

            }

            if ( Object.keys( _sensorParams ).length > 0 )
            {
                this.selected_sensorParams = Object.keys( _sensorParams )[0]
            }

            return _sensorParams
        },
        
        getReport ()
        {
            // 期作 & 專案資訊
            this.RData_cropperiod = this.report_data.cropperiod_meta
            this.RData_cropperiod.start_date = this.$moment( this.RData_cropperiod.start_date ).format('YYYY-MM-DD')
            if (this.RData_cropperiod.end_date) this.RData_cropperiod.end_date = this.$moment( this.RData_cropperiod.end_date ).format('YYYY-MM-DD')
                    

            // 處理裝置資料
            let _device_data = this.report_data.devices //res.data.devices
            
            this.RData_devices = []
            this.RData_weatherboxs = []
            
            for ( let _deviceHashID in _device_data )
            {
                let _device = _device_data[ _deviceHashID ]
              

                _device.hashid   = _deviceHashID
                _device.type     = _device.meta.type
                _device.nickname = ( _device.meta.nickname ? _device.meta.nickname : _device.meta.id + '_' + _deviceHashID )

                if ( _device.meta.type == 'weatherbox' )
                {
                    _device.log_time = this.$tools.date.dateFormat_List( _device.log_time, 'YYYY-MM-DD' )
                    this.RData_weatherboxs.push( _device )
                }
                else if ( _device.meta.type == 'wand' )
                {
                    _device.log_time = this.$tools.date.dateFormat_List( _device.log_time, 'YYYY-MM-DD HH:mm' )
                    this.RData_devices.push( _device )
                }
                // else if ( _device.type == 'extra' )  this.RData_devices.push( _device )

                // if ( _device.air != undefined ) this.RData_weatherboxs.push( _device )
                // else this.RData_devices.push( _device )

            }

            // 紀錄日期時間 array
            if ( this.RData_weatherboxs.length > 0 )
            {
                this.report_log_time = this.RData_weatherboxs[0].log_time
            }
            else if ( this.RData_devices.length > 0 )
            {
                this.report_log_time = this.RData_devices[0].log_time
            }
            else
            {
                this.report_log_time = []
            }
            // console.log( this.RData_weatherboxs )
            // console.log( this.RData_devices ) 
            this.RData_sensorParams = this.getSensorParams();
        },

    }
}
</script>

<style lang="scss" scoped>

.overview-block
{
    vertical-align: top;
    margin: 5px 20px 5px 10px;
    font-size: 1.2rem;
}
.overview-block-title
{
    display: inline-block;
    // vertical-align: middle;
    margin-bottom: -2px;
    margin-right: 10px;
}
.overview-block-body
{
    display: inline-block;
    // vertical-align: middle;
    font-size: 1.8rem;
    color: #008060;
    border-bottom: 1px solid #c3e7e5;
}
.overview-block-unit
{
    display: inline-block;
    // vertical-align: bottom;
    margin-left: 10px;
}
.overview-stress
{
    display: inline-block;
    margin-right: 10px;
    // background-color: #ccdbe2;
    border-radius: 15px;
    border: 1px solid #eed688;

}
.overview-stress-count
{
    display: inline-block;
    margin: 0px 10px 0px 5px;
    font-size: 0.9rem;

    // vertical-align: top;
    // font-size: 0.8rem;
    // padding: 1px 3px;
    // margin-right: 5px;
    // margin-top: -5px;
    // color: #ffffff;
    // background-color: #1595cc; //#6fbd95;
    // border-radius: 3px;
}


.overview-device-title
{
    display: inline-block;
    font-size: 1.5rem;
    color: #385f53;
    border-bottom: 1px solid #b8da8c;
    padding: 1px 15px 1px 8px;
    margin-bottom: 10px;
}
.overview-device-block
{
    display: inline-block;
    padding: 5px;
    margin-bottom: 10px;

    
    .device-info
    {
        display: inline-block;
        margin-right: 10px;
    }
    .device-hashid
    {
        font-size: 0.8rem;
        margin-left: 8px;
    }
    .device-deviceid {
        font-size: 0.75rem;
        margin-left: 5px;
    }
    
    .device-name
    {
        display: inline-block;
        font-size: 1.2rem;
        margin-right: 5px;
        i {
            color: #cea212;
        }
    }
    .device-up-info
    {
        //display: inline-block;
        margin-left: 30px;
        margin-bottom: -3px;
        margin-right: 20px;
        color: #747974;
    }
    .device-down-info
    {
        //display: inline-block;
        margin-left: 25px;
        margin-top: -10px;
        margin-right: 20px;
        color: #747974;
    }
}

</style>
